// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3O7fh","noInteraction":"EventWrapper_noInteraction__1z8LM","pointerPassthrough":"EventWrapper_pointerPassthrough__5EpEJ"};